// src/Services/http/PartnerService.ts
import { TLoginResponse } from "../../types/Login.type";
import { TPartnerSessionRequest, TSetAccountNameRequest } from "../../types/Partner.type";
import { baseUrl, extendHeaders } from "./HelpService";

const PageUrl = baseUrl + "partner/";

const startSession = async (data: TPartnerSessionRequest): Promise<TLoginResponse> => {
    const response = await fetch(PageUrl + "start-session/", {
        method: "POST",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify(data),
    });

    if (!response.ok) {
        let errorMessage = 'Unknown error';
        try {
            const errorData = await response.json();
            errorMessage = errorData.message || errorMessage;
        } catch {
            // Response body is not valid JSON or empty
        }
        throw new Error(`Failed to start session: ${errorMessage}`);
    }

    const json = (await response.json()) as TLoginResponse;
    return json;
};

const setAccountName = async (data: TSetAccountNameRequest): Promise<{ message: string; account_name: string }> => {
    const response = await fetch(PageUrl + "set-account-name/", {
        method: "POST",
        headers: extendHeaders(),
        body: JSON.stringify(data),
    });

    if (!response.ok) {
        let errorMessage = 'Unknown error';
        try {
            const errorData = await response.json();
            errorMessage = errorData.message || errorMessage;
        } catch {
            // Response body is not valid JSON or empty
        }
        throw new Error(`Failed to update account name: ${errorMessage}`);
    }

    const json = (await response.json()) as { message: string; account_name: string };
    return json;
};

const PartnerService = {
    startSession,
    setAccountName,
};

export default PartnerService;